import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
    FormulariosService,
    FormularioAtributo,
    Formulario
} from '../../infrastructure/services/formularios.service';
import { LoaderService } from '../../infrastructure/services/loader.service';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/share';
import { AlertService } from '../../infrastructure/services/alert.service';
import { SxRouterService } from '../../infrastructure/services/sxRouter.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Location } from '@angular/common';

@Component({
    templateUrl: './formulario.atributos.component.html',
})
export class FormularioAtributosComponent implements OnInit {
  public search;
  codFormulario;
  formulario: Observable<Formulario>;
  preguntarSiDeseaBorrar = [];
  codsistema;
  codnegocio;
  codproducto;
  codNestForm = null;

  targetDeleteList: any;

  constructor(private aRoute: ActivatedRoute,
              private alertService: AlertService,
              public loader: LoaderService,
              public sxRouter: SxRouterService,
              private router: Router,
              private formularioService: FormulariosService,
              private modalService: NgxSmartModalService,
              private location: Location) { 

                this.aRoute.params.subscribe(params => {
                  this.codFormulario = params['codFormulario'];
                  this.codsistema = params['codsistema'];
                  this.codnegocio = params['codnegocio'];

                  if(this.codFormulario === undefined &&
                  this.codsistema === undefined ){
                    this.codFormulario = 'null';
                    this.codsistema = 'null';
                  }

                  this.codproducto = params['codproducto'];
                  this.codNestForm = params['codNestForm'];
                  this.initializer();
                });

              }

  ngOnInit() {
  }

  initializer(){
    if (this.codNestForm !== undefined ){
      this.formulario = this.formularioService.getFormulario(this.codNestForm).share();
    }else{
      this.formulario = this.formularioService.getFormulario(this.codFormulario).share();
    }
  }


  // at the export, the system returns a url with the path to download the generated
  // document, with is opened in a new tab
  generateExcel(){
    this.formularioService.exportAttributes(this.codFormulario).subscribe(
      x => {
        window.open(x, '_blank');
      });
  }

  eliminar(atributo) {
    if(this.codNestForm != undefined){
      this.formularioService.eliminarAtributo(this.codNestForm, atributo.codAtributo)
      .then(success => {
        this.alertService.showSuccessMessage('ATRIBUTO_ELIMINADO_OK');

        this.formulario = this.formularioService.getFormulario(this.codNestForm).share();

      });
    }else{
      this.formularioService.eliminarAtributo(this.codFormulario, atributo.codAtributo)
      .then(success => {
        this.alertService.showSuccessMessage('ATRIBUTO_ELIMINADO_OK');

        this.formulario = this.formularioService.getFormulario(this.codFormulario).share();
      });
    }
  }

  checkDeleteList(attr){
    this.targetDeleteList = attr;
    this.modalService.setModalData({}, 'deleteModal');
    this.modalService.getModal('deleteModal').open();
  }

  clickDeleteList(attr){
    this.eliminar(attr);
    this.modalService.getModal('deleteModal').close();
  }

  createNew(){
    if(this.codNestForm != undefined){
      this.router.navigate(['../../../',this.codNestForm , 'nuevo'], { relativeTo: this.aRoute });
    }else{
      this.router.navigate(['.', 'nuevo'], { relativeTo: this.aRoute });
    }
  }

  clickEdit(code : string){
  if(this.codNestForm != undefined){
    this.router.navigate(['../../../',this.codNestForm , code], { relativeTo: this.aRoute });
  }else{
    this.router.navigate(['.', code], { relativeTo: this.aRoute });
  }
 }


  navigateToSimpleQuery(codAtributo) {
    this.sxRouter.navigateToConfigSimpleQueryInNewTab(codAtributo, this.aRoute);
  }

  modifiable(codAtributo: string): boolean {
    const upperCode = codAtributo.toUpperCase();
    return (upperCode !== 'USR_USERNAME') && (upperCode !== 'USR_EMAIL');
  }

  volver() {
    this.router.navigate(['../../'], { relativeTo: this.aRoute });
  }
}




// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/atributos/formulario.atributos.component.ts